import React from 'react';
import { Icon } from './Icon.js';
export const IconCloud = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M18 20H13H6C3.23858 20 1 17.7614 1 15C1 12.2386 3.23858 10 6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10C20.7614 10 23 12.2386 23 15C23 17.7614 20.7614 20 18 20Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconCloud.js.map